import React, { useState } from 'react';

const questions = [
  { label: 'Localização', options: ['Outra ou bem localizada', 'Região central ou difusa'] },
  { label: 'Irradiação', options: ['Sem irradiação', 'Para braço, mandíbula ou dorso'] },
  { label: 'Relação com esforço', options: ['Sem relação evidente', 'Aparece ou piora com esforço'] },
  { label: 'Sintomas associados', options: ['Nenhum dos descritos', 'Falta de ar, náusea ou suor frio'] },
  { label: 'Alívio', options: ['Sem padrão típico', 'Melhora com repouso'] }
];

export default function HistoryQuiz({ onSuggest }) {
  const [answers, setAnswers] = useState(Array(5).fill(null));
  const complete = answers.every((answer) => answer !== null);
  const sum = answers.reduce((total, answer) => total + (answer || 0), 0);
  const suggestion = sum <= 1 ? 0 : sum <= 3 ? 1 : 2;
  const names = ['pouco suspeita', 'moderadamente suspeita', 'altamente suspeita'];

  return (
    <details className="quiz">
      <summary>Quiz da história <span>Orientação didática, não diagnóstica</span></summary>
      <div className="quiz-body">
        <p>Responda às cinco características. A sugestão não substitui a avaliação clínica da história.</p>
        {questions.map((question, index) => (
          <fieldset key={question.label} className="quiz-question">
            <legend>{question.label}</legend>
            {question.options.map((option, choice) => (
              <label key={option}>
                <input type="radio" name={`quiz-${index}`} checked={answers[index] === choice} onChange={() => setAnswers((current) => current.map((value, i) => i === index ? choice : value))} />
                {option}
              </label>
            ))}
          </fieldset>
        ))}
        {complete && <div className="quiz-result">Sugestão didática: <strong>{names[suggestion]}</strong>. <button type="button" className="text-button" onClick={() => onSuggest(suggestion)}>Usar sugestão na História</button></div>}
      </div>
    </details>
  );
}
